// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"ss_a bho_b bho_bj","HomeBaseBanner__hint":"ss_b bho_vh","HomeBaseBanner__link":"ss_c"};